export default __webpack_public_path__ + "static/media/ot-room.efeb7aff.jpg";